<template>
  <li class="hierarchy__list-item list-group-item p-0">
    <router-link v-if="props.name && props.gbin"
                 class="hierarchy__link d-flex flex-wrap align-items-center"
                 :to="getBrandUrl(props.name, props.gbin)">
      <div class="hierarchy__logo">
        <img v-if="props.logoUrl"
             :src="props.logoUrl"
             :alt="props.name"
             class="hierarchy__logo img-fluid" />

        <img v-else
             src="@/assets/images/placeholder-brand.png"
             :alt="props.name"
             class="img-fluid" />
      </div>

      <div class="hierarchy__name ms-2">{{ props.name }}</div>

      <div class="d-flex ms-auto">
        <div class="hierarchy__gbin">GBIN: {{ props.gbin }}</div>

        <div class="hierarchy__icon ms-2">
          <i class="fal fa-chevron-right mt-2"></i>
        </div>
      </div>
    </router-link>

    <ul v-if="props.brands && props.brands.length > 0"
        class="hierarchy__list list-group list-group-flush">
      <template v-for="subBrand in props.brands"
                :key="subBrand.gbin">
        <BrandHierarchyRow v-if="subBrand.gbin != null"
                           :gbin="subBrand.gbin"
                           :name="subBrand.name"
                           :logo-url="subBrand.logoUrl"
                           :brands="subBrand.brands"></BrandHierarchyRow>
      </template>
    </ul>
  </li>
</template>

<script setup>
import { defineProps } from "vue";

import BrandHierarchyRow from "@/components/BrandHierarchyRow.vue";

/**
 *  GETTING & LOADING (API) DATA
 */

const props = defineProps({
  name: String,
  gbin: String,
  logoUrl: String,
  brands: {
    type: Object,
    required: false,
  },
});

function getBrandUrl(name, gbin) {
  name = name
    .normalize("NFD") // Remove accents/diacritics
    .replace(/\p{Diacritic}/gu, "") // Remove accents/diacritics
    .replace(/[^a-zA-Z0-9 \\d]/g, "") // Remove all special characters except space
    .replace(/^\s+|\s+$/g, "") // Remove whitespace at the beginning and end
    .replace(/\s+/g, "-") // Replace spaces between words with a hyphen (-)
    .toLowerCase(); // Convert into lowercase

  return `/brand/${name}/${gbin}`;
}
</script>
